<template>
  <el-dialog
      v-el-drag-dialog
      class="printProductionCardModal"
      append-to-body
      :visible.sync="dialogVisible"
      title="打印标签"
      width="800px">
    <el-form v-if="isPrint">
      <h4 style="border-bottom:1px solid #ccc;margin-bottom:10px">自定义模板</h4>
      <el-row>
        <el-col :span="12">
          <el-form-item label="Logo" style="margin-left:100px">
            <el-checkbox v-model="logoVisible">打印</el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="CE" style="margin-left:100px">
            <el-checkbox v-model="ceVisible">打印</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <h4 style="border-bottom:1px solid #ccc;margin-top:20px">打印模板预览</h4>
    </el-form>
    <template v-if="printModel === 1 ">
      <div v-for="(item, index) in tableData" id="printProductionCard" :key="index">
        <table class="ProductionCardModal" cellpadding="0" cellspacing="0">
          <tr>
            <td style="float:left;width: 128px;">
              <div style="float:left;height:15px;margin-top:5px;width: 120px;height:15px;">
                <img v-if="logoVisible" class="hkIcon" src="../../../../public/img/se/logo_nor1.png">
              </div>
              <div style="float: left; height: 15px;width:220px; font-weight: 700; margin-left: 2px;transform:scale(0.65);transform-origin:0% 60%">{{title}}</div>
              <div v-if="title === 'DC Braking Module'" style="width: 240px; float: left;margin-left:10px"> {{productInfo.specification}}</div>
              <div v-else style="width: 240px; float: left; transform: scale(0.6); transform-origin: 0% 60%;"> {{productInfo.specification}}</div>
              <div v-if="title === 'DC Braking Module'" style="float:left;display:inline-block">
                <span style="width:60px;margin-right:20px;font-weight:700;margin-left:5px">In:{{electricity}}</span>
                <span style="font-weight:700;">{{"I max:" + voltage}}</span>
              </div>
              <div v-else style="float:left;display:inline-block">
                <span style="width:60px;margin-right:20px;font-weight:700;margin-left:5px">In:{{electricity}}</span>
                <span style="font-weight:700;">L:{{inductance}}</span>
              </div>
              <div v-if="title === 'DC Braking Module'" style="float:left;display:inline-blocks">
                <span style="width:60px;margin-right:20px;font-weight:700;margin-left:5px">{{"R min:"+inductance}}</span>
              </div>
              <div v-else style="float:left;display:inline-blocks"> 
                <span style="width:60px;margin-right:20px;font-weight:700;margin-left:5px">AC{{voltage}}</span>
                <span style="font-weight:700;">50-60Hz</span>
              </div>
              <div style="float:left">
                <span style="margin-left:25px;height:20px">Made In China</span>
              </div>
            </td>
            <td style="float:left;width:60px">
              <div style="float:right;height:25px;margin-top:5px;width: 25px; height:25px;">
                <img v-if="ceVisible" class="ceIcon" src="../../../../public/img/se/ce.jpg">
              </div>
              <div style="margin:0;padding:0;height:60px;float: right;">
                <div :id="'qrCode' + item.itemSn" style="width: 60px;height: 80px;" align="center"/>
              </div>
              <span style="margin-right:5px;float:right">{{nowTime}}</span>
            </td>
          </tr>
        </table>
      </div>
    </template>
    <template v-if="printModel === 2 ">
      <div v-for="(item, index) in tableData" id="printProductionCard" :key="index">
        <table class="ProductionCardModal" cellpadding="0" cellspacing="0">
          <tr>
            <td style="float: left; width: 128px;">
              <div style="height:15px;margin-top:5px;width: 120px;height:15px;">
                <img v-if="logoVisible" class="hkIcon" src="../../../../public/img/se/logo_nor1.png">
              </div>
              <div style=" height: 20px;width:220px; font-size:15px;font-weight: 700;transform:scale(0.65);transform-origin:0% 50%;">{{title}}</div>
              <div style="width:128px;display:inline-block">
                <div style="width:40px;height:80px;float: left;transform: rotate(90deg)">
                  <div style="width: 50px;height:12px;transform:scale(0.8);transform-origin:-30% 1090%;font-weight:700">LINE</div>
                  <div style="width: 60px;height:12px;transform:scale(0.8);transform-origin:-100% 1090%;">{{"L1 L2 L3"}}</div>
                  <div style="width: 50px;height:12px;transform:scale(0.8);transform-origin:30% 1090%;">PE</div>
                </div>
                <div style="width: 80px;float: left;">
                  <div style="font-weight:600"> {{productInfo.specification}}</div>
                  <div style="font-weight:600;margin-left:5px">{{electricity}}</div>
                  <div style="width: 80;height: 30px;">
                    <span style="font-weight:600">{{voltage}}</span>
                    <span style="font-weight:600;margin-left:3px">50/60Hz</span>
                  </div>
                </div>
              </div>
            </td>
            <td style="float: left; width: 40px;">
              <div style="margin:0;padding:0;height:40px">
                <div :id="'qrCode' + item.itemSn" style="width: 60px;height: 80px;" align="center"/>
              </div>
              <div style="transform: rotate(-90deg);width:40px;height:80px;">
                <div style="width: 50px;height:12px;transform:scale(0.8);transform-origin:170% 1200%;font-weight:700">LOAD</div>
                <div style="width: 60px;height:12px;transform:scale(0.8);transform-origin:100% 1200%;">{{"L3' L2' L1'"}}</div>
                <div style="width: 50px;height:12px;transform:scale(0.8);transform-origin:250% 1200%;">PE'</div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </template>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button type="primary" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import QRCode from "qrcodejs2";
  export default {
    data() {
      return {
        productInfo: {},
        dialogVisible: false,
        printModel:1,
        tableData: [],
        nowTime:"",
        title:"",
        electricity:"",
        voltage:"",
        inductance:"",
        logoVisible:true,
        ceVisible:true,
        isPrint:true,
      };
    },
    mounted() {
      this.getNowDate();
    },
    methods: {
      open(tableData, productInfo) {
        console.log("table",tableData);
        this.dialogVisible = true;
        this.productInfo = productInfo;
        this.tableData = tableData;
        if (productInfo.specification) {
          let list = productInfo.specification.split("-");
          console.log(list);
          if(list.length ===2) {
            if(list[0] === "DBM") {
              console.log(list);
              this.title = "DC Braking Module";
              this.ceVisible = false;
              switch(list[1]) {
                case "2015": 
                  this.electricity = "15A";
                  this.voltage = "50A";
                  this.inductance = "10R";
                  break;
                case "2030":
                  this.electricity = "30A";
                  this.voltage = "90A";
                  this.inductance = "6.5R";
                  break;
                case "4030":
                  this.electricity = "15A";
                  this.voltage = "50A";
                  this.inductance = "20R";
                  break;
                case "4045":
                  this.electricity = "25A";
                  this.voltage = "75A";
                  this.inductance = "13.6R";
                  break;
                case "4055":
                  this.electricity = "30A";
                  this.voltage = "90A";
                  this.inductance = "12R";
                  break;
                case "4075":
                  this.electricity = "35A";
                  this.voltage = "110A";
                  this.inductance = "10R";
                  break;
                case "4090":
                  this.electricity = "45A";
                  this.voltage = "130A";
                  this.inductance = "7.5R";
                  break;
                case "4110":
                  this.electricity = "50A";
                  this.voltage = "150A";
                  this.inductance = "6.5R";
                  break;
                case "4160":
                  this.electricity = "70A";
                  this.voltage = "200A";
                  this.inductance = "4.5R";
                  break;
                case "4220":
                  this.electricity = "85A";
                  this.voltage = "300A";
                  this.inductance = "3R";
                  break;
                case "4300":
                  this.electricity = "120A";
                  this.voltage = "500A";
                  this.inductance = "2.5R";
                  break;
                case "6110":
                  this.electricity = "50A";
                  this.voltage = "150A";
                  this.inductance = "8.5R";
                  break;
                case "6220":
                  this.electricity = "75A";
                  this.voltage = "180A";
                  this.inductance = "7.5R";
                  break;
                case "6300":
                  this.electricity = "85A";
                  this.voltage = "200A";
                  this.inductance = "6.5R";
                  break;
                default:
                  break;
              }
            }
            
          }else if(list.length < 2) {
            this.printModel = 2;
            this.title = "POWER LINE EMI FILTER";
            switch(list[0]) {
              case "RFI4C100N35":
                this.electricity = "440/250VAC";
                this.voltage = "100A";
                break;
              case "RFI6C30N35":
                this.electricity = "690v";
                this.voltage = "30A";
                break;
              case "RFI11C250N99":
                this.electricity = "1140V";
                this.voltage = "250A";
                break;
              default:
                break;
            }
          }else{
            switch(list[0]) {
              case "BFR" : 
                this.title = "Mine Explosion Reactor";
                break;
              case "ACR":
                this.title = "AC Input Reactor";
                break;
              case "OCR":
                this.title = "AC Output Reactor";
                break;
              case "BCR":
                this.title = "Mine Expolsion Input Reactor";
                break;
              case "DCR":
                this.title = "DC Reactor";
                break;
              case "ATR":
                this.title = "Tuning Reactor";
                break;
              case "BOR":
                this.title = "Mine Expolsion Output Reactor";
                break;
              case "EFR":
                this.title = "Energy Regenerated Reactor";
                break;
              case "VTR":
                this.title = "dv/dt Filter";
                break;
              case "SFR":
                this.title = "Sine Wave Filter";
                break;
              case "LOR":
                this.title = "Load Reactor";
                break;
              case "LCL":
                this.title = "LCL Filter";
                break;
              default:
                break;
            }
            this.electricity = list[1].replace(/\b(0+)/gi, "");
            if (list[2].includes("M")) {
              this.inductance = list[2].replace(/M/, ".") + "mH";
            } else if (list[2].includes("U")) {
              //判断u的位置
              let index = list[2].indexOf("U");
              if (index === 2) {
                this.inductance = list[2].replace(/\b(0+)/gi, "").replace(/U/, ".") + "uH";
              } else if (index === 3) {
                this.inductance = list[2].replace(/\b(0+)/gi, "").replace(/U/, "") + "uH";
              } else {
                return this.$message.error("电感参数错误!!!");
              }
            }
            let v = list[3].substring(0, 3);
            if (v === "0.2") {
              this.voltage = "200V";
            } else if (v === "0.22") {
              this.voltage = "220V";
            } else if (v === "0.4") {
              this.voltage = "380V";
            } else if (v === "0.7") {
              this.voltage = "660V";
            } else if (v === "1.1") {
              this.voltage = "1140V";
            } else if (v === "1.2") {
              this.voltage = "1200V";
            } else if (v === "3.3") {
              this.voltage = "3300V";
            } else {
              return this.$message.error("电压参数不正确或为非标!!!");
            }
          }
        }
        for (let item of this.tableData) {
          this.$nextTick(() => {
            document.getElementById("qrCode" + item.itemSn).innerHTML = "";
            this.bindQRCode(item.itemSn);
          });
        }
      },

      bindQRCode(row) {
        let text = row;
        new QRCode(document.getElementById("qrCode" + row), {
          text: text,
          width: 40,
          height: 40,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      },

      getNowDate() {
        var year = new Date().getFullYear();
        var month = new Date().getMonth()+1;
        var day = new Date().getDate();
        this.nowTime=year+"/"+month+"/"+day;
      },
      print() {
        this.isPrint = false;
        this.$nextTick(()=>{
          document.body.innerHTML = document.getElementById("printProductionCard").parentNode.innerHTML;
          window.print();
          window.location.reload();
          return false;
        });
      },
    },
  };
</script>

<style lang="scss">
.hkIcon {
  width: 120px;
  height:15px;
  object-fit:fill;
}
.ceIcon {
  object-fit:contain;
  width: 25px;
  height:25px;
}
.qrCode {
  width: 60px;
  height: 60px;
  object-fit:contain;
}
.icon2 {
  width: 20px;
  height: 90px;
  object-fit: contain;
}
.printProductionCardModal .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}
.printProductionCardModal .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.printProductionCardModal .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 39px;
  height: 70%;
}

.printProductionCardModal .el-divider--horizontal {
  margin: 10px 0;
}

.printProductionCardModal .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}
</style>
<style lang="scss" scoped>
#printProductionCard {
  width: 50mm;
  height: 25mm;
  margin: 0 auto;
  margin-top: 1.5mm;
  font-size: 10px;
  table {
    width: 100%;
    height: 100%;
    page-break-after: always;
    td {
      box-sizing: border-box;
      height: 7mm;
    }
  }
}
</style>
